/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseSleepCallSleepingEvent = {
  type: "response.sleep_call.sleeping";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  wakeAt?: string | undefined;
};

/** @internal */
export const ResponseSleepCallSleepingEvent$inboundSchema: z.ZodType<
  ResponseSleepCallSleepingEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.sleep_call.sleeping"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  wake_at: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "wake_at": "wakeAt",
  });
});
/** @internal */
export type ResponseSleepCallSleepingEvent$Outbound = {
  type: "response.sleep_call.sleeping";
  sequence_number: number;
  item_id: string;
  output_index: number;
  wake_at?: string | undefined;
};

/** @internal */
export const ResponseSleepCallSleepingEvent$outboundSchema: z.ZodType<
  ResponseSleepCallSleepingEvent$Outbound,
  z.ZodTypeDef,
  ResponseSleepCallSleepingEvent
> = z.object({
  type: z.literal("response.sleep_call.sleeping"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  wakeAt: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    wakeAt: "wake_at",
  });
});

export function responseSleepCallSleepingEventToJSON(
  responseSleepCallSleepingEvent: ResponseSleepCallSleepingEvent,
): string {
  return JSON.stringify(
    ResponseSleepCallSleepingEvent$outboundSchema.parse(
      responseSleepCallSleepingEvent,
    ),
  );
}
export function responseSleepCallSleepingEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseSleepCallSleepingEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseSleepCallSleepingEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseSleepCallSleepingEvent' from JSON`,
  );
}
